// import {adapter} from 'components/system';
// adapter.module.factory('customerExpenditureMonthStatisticsDataProvider', ['dataProviderFactory',  function (dataProviderFactory){
//         return dataProviderFactory.get('middle://customers/statistics/expenditure-month/{customerId}/{month}/{year}');
//     }]);
import { A9Service, AbstractDataProviderV2 } from 'components/system';

@A9Service('customerExpenditureMonthStatisticsDataProvider')
export class CustomerExpenditureMonthStatisticsDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://customers/statistics/expenditure-month/{customerId}/{month}/{year}');
    }
}
